export const reportTypes = [
  {
    value: 'arAgingReport',
    label: 'AR Aging',
  },
  {
    value: 'arAgingDetailedReport',
    label: 'Detailed AR Aging',
  },
  {
    value: 'pnFuneralTrustAgingSummary',
    label: 'PN Funeral Trust Aging',
  },
  {
    value: 'pnFuneralTrustAgingDetailedReport',
    label: 'PN Funeral Trust Detailed Aging',
  },
  {
    value: 'futurePaidinFullReport',
    label: 'Future Paid in Full',
  },
  {
    value: 'payOffReport',
    label: 'Pay Off',
  },
  {
    value: 'interestAndFinancebyCustomer',
    label: 'Interest & Finance by Customer',
  },
  {
    value: 'equityOnCancelledContract',
    label: 'Equity on Cancelled Contract',
  },
  {
    value: 'unpaidTransactionReport',
    label: 'Unpaid Transaction',
  },
  {
    value: 'arAdjustmentReport',
    label: 'AR Adjustment By Type',
  },
  {
    value: 'PIAExceptionReport',
    label: 'PIA Exception',
  },
  {
    value: 'negativeDueReport',
    label: 'Negative Due',
  },
  {
    value: 'pastDueReport',
    label: 'Past Due',
  },
];

export const durationsAutomatedAccounting = [
  {
    value: 'today',
    label: 'Today',
  },
  {
    value: 'last_7',
    label: '7-Days',
  },
  {
    value: 'last_1_months',
    label: 'Month',
  },
  {
    value: 'last_3_months',
    label: '3-Months',
  },
  {
    value: 'last_6_months',
    label: '6-Months',
  },
  {
    value: 'last_1_year',
    label: 'Year',
  },
];

export const pastDuration = [
  { value: 'custom', label: 'Custom' },
  {
    value: 'today',
    label: 'Today',
  },
  {
    value: 'last_7',
    label: 'Last 7 Days',
  },
  {
    value: 'last_1_months',
    label: 'Last Month',
  },
  {
    value: 'last_3_months',
    label: 'Last 3 Months',
  },
  {
    value: 'last_6_months',
    label: 'Last 6 Months',
  },
  {
    value: 'last_1_year',
    label: 'Last Year',
  },
];
export const futureDuration = [
  { value: 'custom', label: 'Custom' },
  {
    value: 'next_30_days',
    label: 'Next 30 Days',
  },
  {
    value: 'next_45_days',
    label: 'Next 45 Days',
  },
  {
    value: 'next_60_days',
    label: 'Next 60 Days',
  },
  {
    value: 'next_120_days',
    label: 'Next 120 Days',
  },
];

export const journalTypes = [
  {
    value: 'salesJournal',
    label: 'Sales Journal',
  },
  {
    value: 'commissionJournal',
    label: 'Commission Journal',
  },
  {
    value: 'cashJournal',
    label: 'Cash Journal',
  },
  {
    value: 'generalJournal',
    label: 'General Journal',
  },
  {
    value: 'trustJournal',
    label: 'Trust Journal',
  },
];

export const monthlyReportTypes = [
  {
    value: 'Trusted_Consumption_Items_With_AT_Changes',
    label: 'Trust Item Consumption',
  },
  {
    value: 'Trusted_Sales_Item',
    label: 'Trust Sales Item',
  },
  {
    value: 'Endowment_Care_Sales_Property',
    label: 'Endowment Care Sales',
  },
];

export const ADDENDUM_IN_PROGRESS = 'In progress';
